module.exports = __webpack_public_path__ + "img/chips2.894bcfe9.webp";